import BaseMovement from './Base'
import PlayerMoveToWithSpeed from './PlayerMoveToWithSpeed'
import BrownianMovement from './BrownianMovement'
import {calculateDistance} from '../helper'
import Vec2D from 'vector2d'
import * as THREE from 'three';

var minDistance = 40;
var maxDistance = 120;
var moveSegment = 40;

export default class OvertakeBall extends BaseMovement {
    constructor(referee, ball, speed) {
        super(referee, null);
        this.Speed = speed;
        this.Ball = ball;
        this.Referee = referee;
    }

    Play(gameSpeed) {       
        return new Promise(function(resolve, reject) {
            this.resolve = resolve;
            this.reject = reject;
            this.move(gameSpeed);
        }.bind(this));
    }

    move(gameSpeed) {
        if(this.IsCancelled){
            this.reject('cancelled');
            return;
        }
        
        this.moveCloser(gameSpeed).then(() => this.move(gameSpeed)).catch((res)=> {
            if(res == 'cancelled')
                this.reject('cancelled');
            else
                throw "unknown error!";
        });
    }
    
    moveCloser(gameSpeed) {   
            
        let currentPos = Vec2D.ObjectVector(this.Referee.CurrentPosition.Left, this.Referee.CurrentPosition.Top);
        let target_referee_location = getTarget(this.Referee, this.Ball);

        if(target_referee_location == null) {
            this.CurrentStep = new BrownianMovement(this.Referee, 40);
            return this.CurrentStep.Play(gameSpeed);
        }
        else {
            let directionVector = Vec2D.ObjectVector(target_referee_location.Left - this.Referee.CurrentPosition.Left, target_referee_location.Top - this.Referee.CurrentPosition.Top);
            let distance = directionVector.length();

            if(distance < 5){            
                this.CurrentStep = new BrownianMovement(this.Referee, 40);
                return this.CurrentStep.Play(gameSpeed);
            }

            let normalizedDirection = directionVector.normalise();
            let multiplied = normalizedDirection.mulS(moveSegment > distance ? distance : moveSegment);
            let newPos = currentPos.add(multiplied);

            this.CurrentStep = new PlayerMoveToWithSpeed(this.Referee, this.Speed, {Left: newPos.x, Top: newPos.y});
            return this.CurrentStep.Play(gameSpeed);
        }
    }

    Cancell() {        
        this.IsCancelled = true;
        if(this.CurrentStep != null){
            this.CurrentStep.Cancell();
        }
    }
}

let topLeft = {x: 180, y: 100 };
let bottomLeft = {x: 180, y: 350 };
let topRight = {x: 720 - 180, y: 100 };
let bottomRight = {x: 720 - 180, y: 350 };

function getTarget(referee, ball) {
    if(refereeIsInSquare(referee)){
        return getIntersectionPoint(referee.CurrentPosition, ball.CurrentPosition);
    }
    else {
        return getIntersectionPoint({Top: 450 / 2, Left: 720 / 2}, ball.CurrentPosition);
    }
}

function refereeIsInSquare(referee) {
    return (referee.CurrentPosition.Left >= topLeft.x &&  referee.CurrentPosition.Top >= topLeft.y &&
            referee.CurrentPosition.Left >= bottomLeft.x &&  referee.CurrentPosition.Top <= bottomLeft.y &&
            referee.CurrentPosition.Left <= topRight.x &&  referee.CurrentPosition.Top >= topRight.y &&
            referee.CurrentPosition.Left <= bottomRight.x &&  referee.CurrentPosition.Top <= bottomRight.y)
}



function getIntersectionPoint(point1, point2) {
    let res = line_intersect(point1.Left, point1.Top, point2.Left, point2.Top, topLeft.x, topLeft.y, bottomLeft.x, bottomLeft.y);
    if(res != null && res.seg1 && res.seg2)
        return {Top: res.y, Left: res.x};
    res = line_intersect(point1.Left, point1.Top, point2.Left, point2.Top, topLeft.x, topLeft.y, topRight.x, topRight.y);
    if(res != null && res.seg1 && res.seg2)
        return {Top: res.y, Left: res.x};
    res = line_intersect(point1.Left, point1.Top, point2.Left, point2.Top, topRight.x, topRight.y, bottomRight.x, bottomRight.y);
    if(res != null && res.seg1 && res.seg2)
        return {Top: res.y, Left: res.x};
    res = line_intersect(point1.Left, point1.Top, point2.Left, point2.Top, bottomLeft.x, bottomLeft.y, bottomRight.x, bottomRight.y);
    if(res != null && res.seg1 && res.seg2)
        return {Top: res.y, Left: res.x};

    return null;
}

function line_intersect(x1, y1, x2, y2, x3, y3, x4, y4)
{
    var ua, ub, denom = (y4 - y3)*(x2 - x1) - (x4 - x3)*(y2 - y1);
    if (denom == 0) {
        return null;
    }
    ua = ((x4 - x3)*(y1 - y3) - (y4 - y3)*(x1 - x3))/denom;
    ub = ((x2 - x1)*(y1 - y3) - (y2 - y1)*(x1 - x3))/denom;
    return {
        x: x1 + ua*(x2 - x1),
        y: y1 + ua*(y2 - y1),
        seg1: ua >= 0 && ua <= 1,
        seg2: ub >= 0 && ub <= 1
    };
}


/** WEBPACK FOOTER **
 ** ./src/components/Animations/Movements/OvertakeBall.js
 **/